center-col<template>
  <v-scale-screen width="1920" height="1080" fullScreen>
  <div class="dashboard-container">
    <AiHeader ref="mychild" :outer="true"></AiHeader>
    <main class="main-content">
      <aside class="column left-col">
        <div class="panel school-panel">
          <!-- <div class="corner top-left"></div>
          <div class="corner top-right"></div>
          <div class="corner bottom-left"></div>
          <div class="corner bottom-right"></div> -->
          <div class="panel-body school-layout">
            <div class="school-logo-area">
              <img :src="shop_img" class="logo-circle" />
            </div>
            <div class="school-text-area">
              <h2 class="school-cn-name">{{ shop_name }}</h2>
            </div>
          </div>
        </div>

        <div class="panel food-safety-panel">
          <!-- <div class="corner top-left"></div>
          <div class="corner top-right"></div>
          <div class="corner bottom-left"></div>
          <div class="corner bottom-right"></div> -->
          <div class="panel-header">
            <span class="panel-title-text">食安公示</span>
          </div>
          <div class="panel-body carousel-container">
            <transition-group name="fade" tag="div" class="carousel-wrapper">
              <div
                v-for="(img, index) in safetyImages"
                :key="index"
                v-show="currentImgIndex === index"
                class="carousel-slide"
              >
                <el-image
                  :src="img"
                  :preview-src-list="safetyImages"
                  :initial-index="index"
                  alt="食安证书"
                  class="cert-image"
                >
                  <div slot="placeholder" class="image-placeholder">
                    <i class="el-icon-loading"></i>
                  </div>
                </el-image>
              </div>
            </transition-group>
            <div class="carousel-indicators">
              <span
                v-for="(item, index) in safetyImages"
                :key="'dot-' + index"
                :class="{ active: currentImgIndex === index }"
                @click="currentImgIndex = index"
              ></span>
            </div>
            <div class="business-overlay">
              <div class="business-title">{{ shop_time }}</div>
              <div class="business-title">{{ shop_time2 }}</div>
            </div>
          </div>
        </div>

        <div class="panel iot-panel">
          <div class="panel-header">
            <span class="panel-title-text">物联网检测设备</span>
            <div
              style="
                display: flex;
                align-items: center;
                color: #ffff !important;
                position: absolute;
                top: 10px;
                right: 10px;
              "
            >
              <div
                style="width: 10px; height: 10px; background-color: green"
              ></div>
              <span style="margin-left: 5px">正常</span>
              <div
                style="
                  width: 10px;
                  height: 10px;
                  background-color: orange;
                  margin-left: 10px;
                "
              ></div>
              <span style="margin-left: 5px">警告</span>
              <div
                style="
                  width: 10px;
                  height: 10px;
                  background-color: red;
                  margin-left: 10px;
                "
              ></div>
              <span style="margin-left: 5px">报警</span>
            </div>
          </div>
          <div class="panel-body iot-container">
            <div class="iot-row top-row">
              <div
                class="iot-card"
                v-for="(item, idx) in iotTopList"
                :key="'top-' + idx"
              >
                <div class="tech-border-glow"></div>
               <div class="iot-header-box">
                 <img
                  src="../assets/image/ziwaixian.png"
                  class="iot-icon-box"
                  v-if="item.name == '紫外线灯'"
                  style="width: 30px;"
                />
                <img
                  src="../assets/image/shuiyin.png"
                  class="iot-icon-box"
                  v-else-if="item.name == '水浸'"
                />
                <img
                  src="../assets/image/ranqi.png"
                  class="iot-icon-box"
                  v-else-if="item.name == '甲烷'"
                />
                <img
                  src="../assets/image/youguo.png"
                  class="iot-icon-box"
                  v-else-if="item.name == '油锅温度'"
                />
                <img
                  src="../assets/image/co2.png"
                  class="iot-icon-box"
                  v-else-if="item.name == '二氧化碳'"
                />
                <img
                  src="../assets/image/donghuo.png"
                  class="iot-icon-box"
                  v-else-if="item.name == '动火离人'"
                />
                <img
                  src="../assets/image/dangshuban.png"
                  class="iot-icon-box"
                  v-else-if="item.name == '挡鼠板'"
                  style="width: 20px;height: 20px;"
                />
                <div class="iot-name-text">{{ item.name }}</div>
               </div>
                <div class="iot-name">{{ item.location }}</div>
                <div v-if="item.type === 'status'" class="iot-status-only">
                  <span
                    class="status-value-big"
                    :class="getStatusColor(item.statusClass)"
                    >{{ item.value }}</span
                  >
                </div>
                <div v-else-if="item.type === 'value'" class="iot-value-box">
                  <span
                    v-if="item.statusText"
                    class="status-badge"
                    :class="getStatusColor(item.statusClass)"
                    >{{ item.statusText }}</span
                  >
                  <div class="big-num digital-font" :class="getStatusColor(item.statusClass)">
                    {{ item.value }}<span class="unit">℃</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="iot-row bottom-row">
              <div
                class="iot-card warehouse-card"
                v-for="(item, idx) in iotBottomList"
                :key="'btm-' + idx"
              >
                <div class="tech-border-glow"></div>
                <div class="wh-header">
                  <span class="wh-name">{{ item.name }}</span>
                </div>
                <div class="wh-data-grid">
                  <div class="wh-data-item">
                    <span class="wh-label">温度</span>
                    <span
                      class="wh-value digital-font"
                      :class="getStatusColor2(item.temp_status)"
                      >{{ item.temp }}<small>℃</small></span
                    >
                  </div>
                  <div class="wh-divider"  v-if="item.hum !== '--'"></div>
                  <div class="wh-data-item" v-if="item.hum !== '--'">
                    <span class="wh-label">湿度</span
                    ><span  
                      class="wh-value digital-font"
                      :class="getStatusColor2(item.wet_status)"
                      >{{ item.hum }}<small>%</small></span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </aside>

      <section class="column center-col">
        <div class="video-wrapper">
          <component :is="currentCenterComponent" ref="centerComponent"></component>
        </div>

        <div class="panel data-table-panel">
          <!-- <div class="corner top-left"></div>
          <div class="corner top-right"></div>
          <div class="corner bottom-left"></div>
          <div class="corner bottom-right"></div> -->

          <div class="panel-header">
            <span class="panel-title-text">菜品环境安全检测</span>
          </div>

          <div class="table-tabs-container">
            <div
              class="tech-tab"
              v-for="(cat, key) in allTableData"
              :key="key"
              :class="{ active: currentTabKey === key }"
              @click="manualSwitchTab(key)"
            >
              <span class="tab-text">{{ cat.title }}</span>
              <div class="tab-glow"></div>
            </div>
          </div>

          <div class="panel-body table-layout-fixed">
            <div class="table-header-wrapper">
              <table class="fixed-header-table">
                <!-- 替换原有的 <thead> 部分 -->
                <div class="table-header-wrapper">
                  <table class="fixed-header-table">
                    <thead>
                      <tr>
                        <!-- 动态生成表头 -->
                        <th
                          v-for="(header, index) in currentHeaders"
                          :key="index"
                          :style="{ width: header.width }"
                        >
                          {{ header.label }}
                        </th>
                      </tr>
                    </thead>
                  </table>
                </div>
              </table>
            </div>

            <div class="table-scroll-mask">
              <div class="scroll-content" :key="currentTabKey">
                <table class="scroll-body-table">
                  <tbody>
                    <tr
                      v-for="(row, rowIndex) in displayList"
                      :key="'row-' + rowIndex"
                    >
                      <!-- 根据表头配置动态渲染单元格 -->
                      <td
                        v-for="(header, colIndex) in currentHeaders"
                        :key="colIndex"
                        :style="{ width: header.width }"
                        :class="{
                          'time-col': header.prop.includes('time'),
                          'status-col': header.prop.includes('result'),
                        }"
                      >
                        <!-- 特殊处理“检测结果”这类需要样式化的列 -->
                        <template v-if="header.prop.includes('result')">
                          <span
                            class="status-badge"
                            :class="row[header.prop] === '合格' ? 'ok' : 'ng'"
                          >
                            {{ row[header.prop] }}
                          </span>
                        </template>
                         <template v-if="header.prop.includes('center_temp')">
                          <span
                            class="status-badge"
                          >
                            {{ row[header.prop] }}℃
                          </span>
                        </template>
                        <!-- 普通列直接显示 -->
                        <template v-else>
                          {{ row[header.prop] }}
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>

      <aside class="column right-col">
        <div class="panel">
          <!-- <div class="corner top-left"></div>
          <div class="corner top-right"></div>
          <div class="corner bottom-left"></div>
          <div class="corner bottom-right"></div> -->
          <div class="panel-header">
            <span class="panel-title-text">AI违规抓拍</span>
          </div>
          <div class="panel-body entry-log-container">
            <div class="log-scroll-wrapper" ref="logScrollWrapper">
              <div class="log-list">
                <div
                  class="log-item"
                  v-for="(item, index) in kitchenEntryLog"
                  :key="index"
                >
                  <div class="log-time">
                    {{ item.push_time }}
                  </div>
                  <div class="face-img-box">
                    <el-image
                      :src="item.alarm_image"
                      alt="抓拍"
                      class="face-img"
                      fit="cover"
                      :preview-src-list="getAllAlarmImages()"
                      :z-index="9999"
                    >
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                      <div slot="placeholder" class="image-slot">
                        加载中<span class="dot">...</span>
                      </div>
                    </el-image>
                  </div>
                  <div class="log-output_class_name">
                    {{ item.output_class_name }}
                  </div>
                </div>
                <!-- 如果没有数据时显示占位 -->
                <div
                  class="log-placeholder"
                  v-if="kitchenEntryLog.length === 0"
                >
                  <span class="placeholder-text">暂无数据</span>
                </div>
              </div>
            </div>
            <!-- 左右滚动按钮 -->
            <!-- <div class="scroll-controls" v-if="kitchenEntryLog.length > 4">
              <button
                class="scroll-btn prev-btn"
                @click="scrollLeft"
                title="向左滚动"
              >
                ◀
              </button>
              <button
                class="scroll-btn next-btn"
                @click="scrollRight"
                title="向右滚动"
              >
                ▶
              </button>
            </div> -->
          </div>
        </div>

        <div class="panel health-fixed-panel">
          <!-- <div class="corner top-left"></div>
          <div class="corner top-right"></div>
          <div class="corner bottom-left"></div>
          <div class="corner bottom-right"></div> -->
          <div class="panel-header">
            <span class="panel-title-text">晨检公示</span>
          </div>
          <div class="panel-body health-layout">
            <div class="health-list-header">
              <span class="col-1">姓名</span>
              <span class="col-2">体温</span>
              <span class="col-3">状态</span>
              <span class="col-4">手部照片</span>
              <span class="col-5">人脸识别照片</span>
              <span class="col-6">晨检时间</span>
            </div>
            <div class="health-scroll-mask">
              <div class="health-scroll-content">
                <div
                  class="health-list-item"
                  v-for="(staff, i) in staffList"
                  :key="'h1-' + i"
                >
                  <span class="col-1">{{ staff.personName }}</span>
                  <span class="col-2 digital-font"
                    >{{ staff.temperature }}℃</span
                  >
                  <span class="col-3">
                    <span class="status-pill ok">{{ staff.health }}</span>
                  </span>
                  <span class="col-4">
                    <!-- 正面照 -->
                    <el-image
                      v-if="staff.picture_img"
                      :src="staff.picture_img"
                      class="person-img"
                      :preview-src-list="getPersonPreviewList(staff)"
                      :initial-index="0"
                      fit="cover"
                      :z-index="9999"
                      hide-on-click-modal
                    >
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </span>
                  <span class="col-5">
                    <!-- 场景照 -->
                    <el-image
                      v-if="staff.scene_img"
                      :src="staff.scene_img"
                      class="scene-img"
                      :preview-src-list="getScenePreviewList(staff)"
                      :initial-index="0"
                      fit="cover"
                      :z-index="9999"
                      hide-on-click-modal
                    >
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </span>
                  <span  class="col-6">{{ staff.date }}{{ staff.checktime_text }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel">
          <!-- <div class="corner top-left"></div>
          <div class="corner top-right"></div>
          <div class="corner bottom-left"></div>
          <div class="corner bottom-right"></div> -->
          <div class="panel-header">
            <span class="panel-title-text">健康证公示</span>
          </div>
          <div class="panel-body health-cert-wrapper">
            <transition name="fade" mode="out-in">
              <div class="health-cert" :key="certIndex">
                <div
                  class="cert-card"
                  v-for="(cert, index) in visibleCerts"
                  :key="cert.id"
                >
                  <div class="cert-content">
                    <!-- 替换 img 为 el-image -->
                    <el-image
                      :src="cert.pic_image"
                      class="cert-photo"
                      :preview-src-list="previewSrcList"
                      :initial-index="index"
                      fit="cover"
                      :z-index="9999"
                      hide-on-click-modal
                    >
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </aside>
    </main>
  </div>
  </v-scale-screen>
</template>

<script>
// 修改点：引入 flv.js
import flvjs from "../assets/js/flv.min.js";
import AiHeader from "../components/aiHeader.vue";
import VideoSurveillance from "../components/VideoSurveillance.vue";
import TaskModule from "../components/TaskModule.vue";
import {
  getIotInfo2,
  getRetentionTable,
  getPesticideBymachine,
  getXdjl,
  getFoodCenterTemperature,
  getFoodImgs,
  getAiBox,
  getShopImage,
  getMorningCheckByMachine,
  getHealthTable,
} from "../api/api";
// 引入混入
import { myMixin } from "../common/common.js";

export default {
  name: "Dashboard",
  data() {
    return {
      currentTime: "",
      currentTimeSmall: "",
      timer: null,
      carouselTimer: null,
      tableTabTimer: null,
      currentImgIndex: 0,

      // === 健康证 ===
      certIndex: 0,
      certTimer: null,
      healthCertList: [],
      // === 后厨记录 ===
      kitchenEntryLog: [],

      // === 多表格数据 ===
      currentTabKey: "ingredients",
      // 在 data 的 allTableData 中修改
      allTableData: {
        ingredients: {
          title: "农残检测",
          headers: [
            // 新增
            { prop: "food_name", label: "名称", width: "15%" },
            { prop: "jiancezhi", label: "检测值", width: "20%" },
            { prop: "status", label: "检测结果", width: "15%" },
            { prop: "createtime", label: "检测时间", width: "25%" },
            { prop: "check_user", label: "检测人", width: "25%" }
          ],
          list: [],
        },
        finished: {
          title: "消毒检测",
          headers: [
            // 新增
            { prop: "room_name", label: "档口", width: "20%" },
            { prop: "xd_type", label: "消毒类型", width: "20%" },
            { prop: "name", label: "工用具名称", width: "10%" },
            { prop: "method", label: "消毒方法", width: "20%" },
            { prop: "createtime", label: "消毒时间", width: "30%" },
            {prop: "operator_user", label: "操作人", width: "20%"}
          ],
          list: [],
        },
        samples: {
          title: "留样检测",
          headers: [
            { prop: "food_name", label: "名称", width: "25%" },
            { prop: "meal_name", label: "餐次", width: "15%" },
            {prop: "temp", label: "保存条件", width: "15%"},
            { prop: "weight", label: "重量", width: "15%" },
            { prop: "createtime", label: "留样时间", width: "25%" },
            {prop: "retention_user", label: "留样人", width: "20%"},
          ],
          list: [],
        },
        temperature: {
          title: "菜品中心温度检测",
          headers: [
            // 新增]
            { prop: "food_name", label: "菜品名称", width: "25%" },
            { prop: "meal_name", label: "餐次", width: "20%" },
            { prop: "center_temp", label: "中心温度", width: "15%" },
            { prop: "action_date", label: "检测时间", width: "25%" },
            { prop: "check_user", label: "检测人", width: "30%" },
          ],
          list: [],
        },
      },

      safetyImages: [],
      iotTopList: [],
      iotBottomList: [],
      staffList: [],
      currentCenterComponent: 'TaskModule', // 默认为任务模块
      modePollTimer: null, // 轮询定时器
    };
  },
  components: {
    AiHeader,
    VideoSurveillance,
    TaskModule
  },
  mixins: [myMixin],
  computed: {
    previewSrcList() {
      // 提取所有图片的 URL 用于预览
      return this.visibleCerts
        .filter((cert) => cert.pic_image)
        .map((cert) => cert.pic_image);
    },
    displayList() {
      if (
        this.allTableData &&
        this.currentTabKey &&
        this.allTableData[this.currentTabKey]
      ) {
        return this.allTableData[this.currentTabKey].list || [];
      }
      return [];
    },
    visibleCerts() {
      const start = this.certIndex;
      let list = this.healthCertList.slice(start, start + 4);
      return list;
    },
    // 新增：获取当前标签的表头配置
    currentHeaders() {
      const currentTab = this.allTableData[this.currentTabKey];
      return (currentTab && currentTab.headers) || [];
    },
  },
  mounted() {
    this.getIotInfo2();
    this.getRetentionTableData();
    this.getPesticideheck();
    this.getXdjl();
    this.getFoodCenterTemperature();
    this.getFoodImgs();
    this.getShopImage();
    this.getHealthcheckTable();
    this.getHealthTable();
    // 加载视频监控数据
    this.$nextTick(() => {
      setTimeout(() => {
        this.startLogAutoScroll();
      }, 2500); // 延迟启动，确保DOM渲染完成
    });
    this.updateTime();
    this.timer = setInterval(this.updateTime, 1000);
    this.startCarousel();
    this.startTableRotator();
    this.startCertCarousel();
    
    // 启动轮询展示模式
    this.pollDisplayMode(); // 立即执行一次
    // this.modePollTimer = setInterval(this.pollDisplayMode, 5000); // 每5秒轮询一次
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
    if (this.carouselTimer) clearInterval(this.carouselTimer);
    if (this.tableTabTimer) clearInterval(this.tableTabTimer);
    if (this.certTimer) clearInterval(this.certTimer);
    if (this.modePollTimer) clearInterval(this.modePollTimer);
    this.stopLogAutoScroll();
  },
  methods: {
    // 获取所有 alarm_image 组成的数组
    getAllAlarmImages() {
      return this.kitchenEntryLog.map((item) => item.alarm_image);
    },
    getPersonPreviewList(staff) {
      // 正面照和背面照一起预览
      const list = [];
      if (staff.picture_img) list.push(staff.picture_img);
      if (staff.picture_back_img) list.push(staff.picture_back_img);
      return list;
    },
    getScenePreviewList(staff) {
      // 场景照预览
      return staff.scene_img ? [staff.scene_img] : [];
    },
    // 向左滚动
    scrollLeft() {
      const scrollWrapper = this.$refs.logScrollWrapper;
      if (!scrollWrapper) return;

      const itemWidth = 180;
      const gap = 15;
      const scrollAmount = itemWidth + gap;
      const targetLeft = Math.max(scrollWrapper.scrollLeft - scrollAmount, 0);

      // 使用 $nextTick 确保操作在DOM更新后执行
      this.$nextTick(() => {
        scrollWrapper.scrollLeft = targetLeft;
      });
    },

    // 向右滚动
    scrollRight() {
      const scrollWrapper = this.$refs.logScrollWrapper;
      if (!scrollWrapper) return;

      const itemWidth = 180; // 与CSS中.log-item的width一致
      const gap = 15; // 与CSS中.log-list的gap一致
      const scrollAmount = itemWidth + gap;

      scrollWrapper.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    },

    // 启动后厨记录自动滚动
    startLogAutoScroll() {
      const scrollWrapper = this.$refs.logScrollWrapper;
      if (!scrollWrapper) return;

      const scrollWidth = scrollWrapper.scrollWidth;
      const clientWidth = scrollWrapper.clientWidth;

      // 如果内容不超过容器宽度，不需要滚动
      if (scrollWidth <= clientWidth + 10) {
        scrollWrapper.classList.remove("has-content");
        return;
      }

      // 添加有内容的类，显示渐变遮罩
      scrollWrapper.classList.add("has-content");

      let direction = 1; // 1向右，-1向左
      let isPaused = false;

      this.logScrollTimer = setInterval(() => {
        if (isPaused) return;

        scrollWrapper.scrollLeft += direction;

        // 检查是否滚动到边界
        if (
          scrollWrapper.scrollLeft >= scrollWidth - clientWidth - 10 &&
          direction === 1
        ) {
          // 到最右边，暂停2秒后向左滚动
          isPaused = true;
          setTimeout(() => {
            direction = -1;
            isPaused = false;
          }, 2000);
        } else if (scrollWrapper.scrollLeft <= 10 && direction === -1) {
          // 到最左边，暂停2秒后向右滚动
          isPaused = true;
          setTimeout(() => {
            direction = 1;
            isPaused = false;
          }, 2000);
        }
      }, 40); // 每40ms滚动1px，速度适中
    },

    // 停止自动滚动
    stopLogAutoScroll() {
      if (this.logScrollTimer) {
        clearInterval(this.logScrollTimer);
        this.logScrollTimer = null;
      }
    },
    // 温湿度
    updateBottomList(tempData) {
      // 如果tempData为空，使用默认数据
      if (!tempData || tempData.length === 0) {
        return [
          { name: "冷藏库", icon: "❄️", temp: "--", hum: "--" },
          { name: "冷冻库", icon: "🧊", temp: "--", hum: "--" },
          { name: "干货库", icon: "📦", temp: "--", hum: "--" },
          { name: "粮油库", icon: "🌾", temp: "--", hum: "--" },
        ];
      }

      // 3. 根据接口返回的数据动态生成列表
      const bottomList = tempData.map((item, index) => {
        // 构建显示名称，保留原有的编号格式(${index + 1}#)
        const displayName = `${item.name}`;

        return {
          name: displayName,
          temp: item.temp || "--", // 温度
          hum: item.wet || "--", // 湿度，注意字段名是wet
          temp_status: item.temp_status || "未知", // 状态信息
          wet_status: item.wet_status || "未知", 
        };
      });

      return bottomList;
    },
    // 其它硬件设备
    processIoTDataSimple(resData) {
      // 设备配置
      const deviceConfig = {
        ultraviolet: {
          name: "紫外线灯",
          type: "status",
          valueField: "status",
          defaultValue: "关闭",
        },
        water: {
          name: "水浸",
          type: "status",
          valueField: "value",
          defaultValue: "正常",
        },
        jiawan: {
          name: "燃气泄漏",
          type: "status",
          valueField: "status",
          defaultValue: "正常",
        },
        oil: {
          name: "油锅温度",
          type: "value",
          valueField: "num",
          defaultValue: "正常",
          // format: (val) => parseFloat(val || 0).toFixed(1),
        },
        co2: {
          name: "二氧化碳",
          type: "status",
          valueField: "status",
          defaultValue: "正常",
          // format: (val) => (val ? val.toString() : "0"),
        },
        fireNoPerson: {
          name: "动火离人",
          type: "status",
          valueField: "status",
          defaultValue: "正常",
        },
        mouseBoard: {
          name: "挡鼠板",
          type: "status",
          valueField: "status",
          defaultValue: "正常",
        },
      };

      // 状态分类逻辑
      const getStatusClass = (deviceKey, status, value) => {
        const config = deviceConfig[deviceKey];
        

        if (config.type === "value") {
          // 数值型：优先使用API返回的status，如果status是警告/报警，直接返回对应class
          if (status === "警告") return "warn";
          if (status === "报警") return "alarm";

          // 否则根据阈值判断
          const numValue = parseFloat(value);
          if (!isNaN(numValue)) {
            if (deviceKey === "oil" && numValue > 200) return "alarm";
            if (deviceKey === "co2" && numValue > 1000) return "alarm";
          }
          return "normal";
        }

        // 状态型
        if (status === "正常" || status === "关闭" || status === "无水") return "success";
        if (status === "警告") return "warn";
        if (status === "异常" || status === "开启") return "error";
        return "normal";
      };

      // 检查数据是否存在
      if (!resData || !resData.data) {
        console.error("数据格式错误");
        this.iotTopList = Object.entries(deviceConfig).map(([key, config]) => ({
          name: config.name,
          type: config.type,
          value: config.defaultValue,
          statusClass: "normal",
        }));
        return;
      }

      // 处理数据
      this.iotTopList = Object.entries(deviceConfig).map(([key, config]) => {
        const deviceData = resData.data[key];
           

        if (!deviceData) {
          return {
            name: config.name,
            type: config.type,
            value: config.defaultValue,
            statusClass: "normal",
          };
        }

        const rawValue = deviceData[0][config.valueField];
        const location = deviceData[0]?.location;
        const status = deviceData[0].status || config.defaultValue;

        // 优先使用API返回的设备名称，如果没有则使用配置中的默认名称
        // 检查设备数据中是否有 name、deviceName 或 displayName 字段
        const deviceNameFromApi = deviceData[0]?.name

        // 如果有位置信息且有API返回的名称，组合显示；否则使用其中一个
        let displayName = config.name;
        if (deviceNameFromApi) {
          displayName = deviceNameFromApi;
        }

        const displayValue = config.format
          ? config.format(rawValue)
          : rawValue || config.defaultValue;

        // 对于数值型设备，需要保存状态文本用于显示
        const statusText = config.type === 'value' ? status : undefined;

        return {
          name: displayName,
          location: location,
          type: config.type,
          value: displayValue,
          statusText: statusText, // 保存状态文本（警告、正常等）
          statusClass: getStatusClass(key, status, displayValue),
          rawData: deviceData, // 可选
        };
      });
      console.log(this.iotTopList,'this.iotTopList');
      
    },
    // 获取信息展示
    async getIotInfo2() {
      const res = await getIotInfo2();
      this.iotBottomList = this.updateBottomList(res.data.data.temp);      
      this.processIoTDataSimple(res.data);
      console.log(this.iotBottomList,'this.iotBottomList');
      
    },
    // 获取留样记录
    async getRetentionTableData() {
      const res = await getRetentionTable();
      this.allTableData.samples.list = res.data.data[0].data;
    },
    // 获取农残记录
    async getPesticideheck() {
      const res = await getPesticideBymachine();
      this.allTableData.ingredients.list = res.data.data.data || [];
    },
    // 获取菜品中心温度记录
    async getFoodCenterTemperature() {
      const res = await getFoodCenterTemperature();
      this.allTableData.temperature.list = res.data.data;      
    },
    // 获取消毒记录
    async getXdjl() {
      const res = await getXdjl();
      this.allTableData.finished.list = res.data.data.data || [];
      console.log(res.data.data,'消毒记录');
    },
    // 获取食安公示
    async getFoodImgs() {
      const res = await getFoodImgs();
      this.safetyImages = res.data.data.imgs;
    },
    // 获取视频监控摄像头列表
    async getAiBox() {
      try {
        const res = await getAiBox();

        if (res.data && res.data.data && res.data.data.channel) {
          // 处理摄像头数据，只保留需要的字段
          this.cameraList = res.data.data.channel.map((item, index) => ({
            id: index + 1, // 使用数组索引+1作为ID，或者用 channel_address
            location: item.channel_address, // 根据channel_address生成位置
            url: item.flv_url, // 使用接口返回的flv_url
            // 保存原始数据，如果需要的话
            rawData: item,
          }));
          // 如果已经初始化过视频播放器，需要重新初始化
          if (this.$refs.videoRefs && this.$refs.videoRefs.length > 0) {
            this.reloadVideoPlayers();
          }
        } else {
          console.warn("摄像头数据为空，使用默认数据");
          this.loadDefaultCameraList();
        }
      } catch (error) {
        console.error("获取摄像头数据失败:", error);
        this.loadDefaultCameraList();
      }
    },
    // AI抓拍
    async getShopImage() {
      const res = await getShopImage();
      this.kitchenEntryLog = res.data.data.shopImgs.data;
    },
    // 获取晨检记录
    async getHealthcheckTable() {
      const res = await getMorningCheckByMachine();
      this.staffList = res.data.data.data;
      console.log(this.staffList,'this.staffList');
      
    },
    async getHealthTable() {
      const res = await getHealthTable();
      this.healthCertList = res.data.data[0].data;
    },
    // === 原有逻辑 ===
    // 轮询获取展示模式
    async pollDisplayMode() {
      if (this.home_center === 'shopOwner') {
            this.currentCenterComponent = 'TaskModule';
          } else if (this.home_center === 'video') {
            this.currentCenterComponent = 'VideoSurveillance';
          }
    },

    updateTime() {
      const now = new Date();
      this.currentTime = now.toLocaleString("zh-CN", { hour12: false });
      this.currentTimeSmall = now.toLocaleTimeString("zh-CN", {
        hour12: false,
      });
    },
    startCarousel() {
      this.carouselTimer = setInterval(() => {
        this.currentImgIndex =
          (this.currentImgIndex + 1) % this.safetyImages.length;
      }, 5000);
    },
    startTableRotator() {
      const keys = Object.keys(this.allTableData);
      this.tableTabTimer = setInterval(() => {
        let currentIndex = keys.indexOf(this.currentTabKey);
        let nextIndex = (currentIndex + 1) % keys.length;
        this.currentTabKey = keys[nextIndex];
      }, 30000);
    },
    startCertCarousel() {
      this.certTimer = setInterval(() => {
        this.certIndex = this.certIndex + 2;
        if (this.certIndex >= this.healthCertList.length) {
          this.certIndex = 0;
        }
      }, 6000);
    },
    manualSwitchTab(key) {
      this.currentTabKey = key;
      clearInterval(this.tableTabTimer);
      this.startTableRotator();
    },
    getStatusColor(status) {
      if (status === "success") return "status-green";
      if (status === "normal") return "status-green";
      if (status === "warn") return "status-orange";
      if (status === "alarm" || status === "error") return "status-red";
      return "";
    },
    getStatusColor2(status) {
      if (status == "正常") return "status-green";
      if (status == "警告") return "status-orange";
      if (status == "报警") return "status-red";
      return "";
    },
  },
};
</script>

<style scoped>
/* === 全局基础 === */
* {
  box-sizing: border-box;
}
.dashboard-container {
  width: 100%;
  height: 100%;
  background-color: #050a1f;
  color: #fff;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Microsoft YaHei",
    Arial, sans-serif;
  display: flex;
  flex-direction: column;
}

/* === 布局 === */
.main-content {
  flex: 1;
  display: flex;
  padding: 15px;
  gap: 15px;
  overflow: hidden;
}
.column {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.left-col,
.right-col {
  width: 25%;
}
/* === 右侧布局调整 === */
.right-col {
  width: 30%;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/* 第一个面板：进入后厨记录 - 分配固定高度 */
.right-col > .panel:nth-child(1) {
  flex: 0 0 28%; /* 大约占35%高度 */
  min-height: 0; /* 重要 */
}

/* 第二个面板：晨检公示 - 分配固定高度 */
.health-fixed-panel {
  flex: 0 0 29% !important; /* 大约占35%高度 */
  min-height: 0;
}

/* 第三个面板：健康证公示 - 分配剩余高度 */
.right-col > .panel:nth-child(3) {
  flex: 1; /* 占据剩余空间 */
  min-height: 0; /* 重要：允许收缩 */
}
.center-col {
  width: 45%;
}

.video-wrapper {
  flex: 1.5;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* === 面板通用 === */
.panel {
  background: rgba(13, 22, 48, 0.8);
  border: 1px solid #102844;
  box-shadow: inset 0 0 20px rgba(0, 161, 255, 0.05);
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 1;
  border-radius: 4px;
}
.corner {
  position: absolute;
  width: 15px;
  height: 15px;
  border-style: solid;
  border-color: #378da0;
  /* box-shadow: 0 0 5px #00d2ff; */
  pointer-events: none;
}
.top-left {
  top: -1px;
  left: -1px;
  border-width: 2px 0 0 2px;
}
.top-right {
  top: -1px;
  right: -1px;
  border-width: 2px 2px 0 0;
}
.bottom-left {
  bottom: -1px;
  left: -1px;
  border-width: 0 0 2px 2px;
}
.bottom-right {
  bottom: -1px;
  right: -1px;
  border-width: 0 2px 2px 0;
}

.panel-header {
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 25px;
  background: linear-gradient(
    90deg,
    rgba(0, 161, 255, 0.3) 0%,
    rgba(0, 78, 146, 0.1) 60%,
    rgba(0, 0, 0, 0) 100%
  );
  border-bottom: 1px solid rgba(0, 161, 255, 0.3);
  position: relative;
  flex-shrink: 0;
}
.panel-header::before {
  content: "";
  width: 4px;
  height: 16px;
  background: #00d2ff;
  margin-right: 10px;
  box-shadow: 0 0 8px #00d2ff;
}
.panel-title-text {
  font-size: 1.1rem;
  color: #fff;
  font-weight: bold;
  letter-spacing: 1px;
  text-shadow: 0 0 5px rgba(0, 161, 255, 0.5);
}
.panel-body {
  flex: 1;
  padding: 10px;
  overflow: hidden;
  position: relative;
}

/* === 左侧模块 === */
.school-panel {
  flex: 0 0 auto;
}
.school-layout {
  display: flex;
  align-items: center;
  padding: 12px;
}
.school-logo-area .logo-circle {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  /* border: 1px solid #00d2ff; */
  box-shadow: 0 0 15px rgba(0, 210, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0056b3;
  font-weight: bold;
  font-size: 1.2rem;
}
.school-text-area {
  margin-left: 15px;
}
.school-cn-name {
  font-size: 1.4rem;
  margin: 0 0 5px;
  color: #fff;
  text-shadow: 0 0 5px #00a1ff;
}

.food-safety-panel {
  flex: 1.75;
}
.carousel-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0;
}
.carousel-wrapper {
  position: relative;
  flex: 1;
  width: 100%;
  height: 100%;
  background: transparent;
}
.carousel-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cert-image {
  width: auto;
  height: 100%;
  display: block;
}
.cert-image .el-image__inner {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.carousel-indicators {
  position: absolute;
  bottom: 90px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 8px;
  z-index: 10;
}
.carousel-indicators span {
  width: 8px;
  height: 8px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  cursor: pointer;
}
.carousel-indicators span.active {
  background: #00d2ff;
  box-shadow: 0 0 5px #00d2ff;
}

.business-overlay {
  width: 100%;
  height: 80px;
  padding: 5px 15px;
  z-index: 20;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: space-between;
}
.business-title {
  font-weight: bold;
  font-size: 0.96rem;
  color: #fff;
  margin-bottom: 10px;
}
.business-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 2px;
  column-gap: 10px;
  font-weight: bold;
  font-size: 0.9rem;
  color: #fff;
}
.b-item {
  font-size: 0.85rem;
  color: #fff;
  white-space: nowrap;
}
.b-item span {
  color: #fff;
  margin-right: 5px;
  font-size: 0.8rem;
}

/* === 物联感知 === */
.iot-panel {
  flex: 1.5;
}
.iot-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 5px;
}
.iot-row {
  display: grid;
  gap: 8px;
  flex: 1;
}
.top-row {
  grid-template-columns: repeat(4, 1fr);
}
.bottom-row {
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
}
.iot-card {
  position: relative;
  background: linear-gradient(
    135deg,
    rgba(0, 161, 255, 0.05) 0%,
    rgba(0, 40, 80, 0.3) 100%
  );
  border: 1px solid rgba(0, 161, 255, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  box-shadow: inset 0 0 15px rgba(0, 161, 255, 0.05);
}
.tech-border-glow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid transparent;
  box-shadow: 0 0 5px rgba(0, 210, 255, 0.1);
  pointer-events: none;
}
.iot-card:hover .tech-border-glow {
  box-shadow: 0 0 10px rgba(0, 210, 255, 0.4),
    inset 0 0 5px rgba(0, 210, 255, 0.2);
  border-color: rgba(0, 161, 255, 0.4);
}
.iot-header-box {
  width: 100%;
  height: 36px;
  background: rgba(0, 161, 255, 0.15);
  border-bottom: 1px solid rgba(0, 161, 255, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 10px;
  flex-shrink: 0;
}
.iot-icon-box {
  width: 25px;
  height: 25px;
  flex-shrink: 0;
}
.iot-name-text {
  font-size: 0.85rem;
  color: #fff;
  white-space: nowrap;
  font-weight: 500;
}
.iot-name {
  font-size: 0.8rem;
  color: #a0cfff;
  white-space: nowrap;
  margin-bottom: 2px;
  opacity: 0.9;
  margin-top: 4px;
}
.iot-status-only {
  margin-top: 4px;
}
.status-value-big {
  font-size: 0.9rem;
  font-weight: bold;
  letter-spacing: 1px;
  display: block;
}
.status-green {
  color: green;
}
.status-orange {
  color: orange;
  text-shadow: 0 0 8px rgba(255, 170, 0, 0.6);
}
.status-red {
  color: red;
  text-shadow: 0 0 8px rgba(255, 51, 0, 0.6);
}
.iot-value-box {
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
}
.big-num {
  font-size: 1rem;
  font-weight: bold;
}
.iot-value-box .status-badge {
  font-size: 0.75rem;
  padding: 1px 6px;
  border-radius: 2px;
  display: inline-block;
}
.unit {
  font-size: 0.65rem;
  margin-left: 2px;
}
.warehouse-card {
  padding: 5px;
  justify-content: space-around;
}
.wh-header {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 5px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  width: 100%;
  padding-bottom: 3px;
  justify-content: center;
}
.wh-icon {
  font-size: 1rem;
}
.wh-name {
  font-size: 0.9rem;
  color: #fff;
  font-weight: bold;
}
.wh-data-grid {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.wh-data-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}
.wh-label {
  font-size: 0.9rem;
  color: #fff;
  transform: scale(0.9);
}
.wh-value {
  font-size: 1rem;
  font-weight: bold;
}

.wh-value small {
  font-size: 0.6rem;
  margin-left: 1px;
  opacity: 0.7;
}
.wh-divider {
  width: 1px;
  height: 20px;
  background: rgba(255, 255, 255, 0.1);
}
.digital-font {
  font-family: "Arial", sans-serif;
  letter-spacing: 0.5px;
}

/* === 中间区域：多表格数据 === */
.data-table-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.table-tabs-container {
  display: flex;
  gap: 2px;
  padding: 8px 15px 0 15px;
  background: rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(0, 161, 255, 0.3);
  flex-shrink: 0;
}
.tech-tab {
  padding: 5px 20px;
  font-size: 0.85rem;
  color: #8899aa;
  cursor: pointer;
  background: rgba(13, 30, 60, 0.5);
  border: 1px solid rgba(0, 161, 255, 0.2);
  border-bottom: none;
  transform: skewX(-20deg);
  margin-right: 5px;
  position: relative;
  transition: all 0.3s;
  /* 新增 */
  flex-grow: 1;
  text-align: center;
}
.tech-tab .tab-text {
  display: block;
  transform: skewX(20deg);
  font-weight: bold;
}
.tech-tab.active {
  background: linear-gradient(
    to bottom,
    rgba(0, 161, 255, 0.2),
    rgba(0, 161, 255, 0.05)
  );
  border-color: #00d2ff;
  color: #fff;
  box-shadow: 0 -2px 10px rgba(0, 161, 255, 0.2);
}
.tech-tab.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #00ffcc;
  box-shadow: 0 0 5px #00ffcc;
}
.table-layout-fixed {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0;
  position: relative;
  overflow: hidden;
}
.table-header-wrapper {
  background: rgba(0, 161, 255, 0.1);
  border-bottom: 1px solid #1c3a63;
  flex-shrink: 0;
  z-index: 2;
}
.fixed-header-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}
.fixed-header-table th {
  padding: 10px 5px;
  color: #00d2ff;
  font-size: 0.9rem;
  text-align: center;
}
.table-scroll-mask {
  flex: 1;
  overflow: hidden;
  position: relative;
  height: 100%;
}
.scroll-content {
  width: 100%;
  animation: moveUp 180s linear infinite;
  will-change: transform;
}
.scroll-content:hover {
  animation-play-state: paused;
}
@keyframes moveUp {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%);
  }
}
.scroll-body-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}
.scroll-body-table td {
  padding: 8px 5px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  font-size: 0.85rem;
  color: #ddd;
}
.scroll-body-table tr:nth-child(even) {
  background: rgba(255, 255, 255, 0.02);
}
.status-badge {
  padding: 2px 6px;
  border-radius: 2px;
  font-size: 0.75rem;
}
.status-badge.ok {
  border: 1px solid #00ff00;
  color: #00ff00;
  background: rgba(0, 255, 0, 0.1);
}
.status-badge.ng {
  border: 1px solid #ff3300;
  color: #ff3300;
  background: rgba(255, 51, 0, 0.1);
}
.time-col {
  font-family: monospace;
  color: #a0cfff;
}
/* === 右侧模块：进入后厨记录 - 横向滚动 === */
.entry-log-container {
  padding: 10px;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  position: relative;
}

/* 横向滚动包装器 */
.log-scroll-wrapper {
  flex: 1;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 8px; /* 为水平滚动条留出空间 */
  position: relative;
  scroll-behavior: smooth;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 210, 255, 0.8) rgba(13, 22, 48, 0.3);
  min-height: 0;
  display: flex;
  align-items: center;

  /* 隐藏默认滚动条，使用自定义 */
  &::-webkit-scrollbar {
    height: 6px;
    background: transparent;
  }

  &::-webkit-scrollbar-track {
    background: rgba(13, 22, 48, 0.2);
    border-radius: 3px;
    margin: 0 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: linear-gradient(
      to right,
      rgba(0, 210, 255, 0.7),
      rgba(0, 161, 255, 0.4)
    );
    border-radius: 3px;
    border: 1px solid rgba(0, 210, 255, 0.3);
    box-shadow: 0 0 6px rgba(0, 210, 255, 0.3),
      inset 0 0 8px rgba(0, 210, 255, 0.2);
    transition: all 0.3s ease;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(
      to right,
      rgba(0, 255, 255, 0.9),
      rgba(0, 161, 255, 0.7)
    );
    box-shadow: 0 0 10px rgba(0, 210, 255, 0.5),
      inset 0 0 10px rgba(0, 210, 255, 0.3);
  }

  &::-webkit-scrollbar-button {
    display: none;
  }
}

/* 横向渐变遮罩效果 */
.log-scroll-wrapper.has-content::before,
.log-scroll-wrapper.has-content::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 8px;
  width: 15px;
  z-index: 5;
  pointer-events: none;
}

.log-scroll-wrapper.has-content::before {
  left: 0;
  background: linear-gradient(to right, rgba(5, 10, 31, 0.95), transparent);
}

/* .log-scroll-wrapper.has-content::after {
  right: 0;
  background: linear-gradient(to left, rgba(5, 10, 31, 0.95), transparent);
} */

/* 横向日志列表 */
.log-list {
  display: flex;
  gap: 5px;
  padding: 0 3px;
  width: max-content; /* 让内容撑开宽度 */
  min-width: 100%;
  align-items: stretch; /* 让所有项目拉伸到相同高度 */
}

/* 单个日志项目 - 固定宽度 */
.log-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 160px; /* 固定宽度 */
  min-width: 160px; /* 确保最小宽度 */
  height: 160px; /* 固定高度 */
  flex-shrink: 0; /* 防止项目被压缩 */
  opacity: 0.9;
  transition: all 0.3s ease;
  border-radius: 6px;
  background: rgba(0, 40, 80, 0.1);
  border: 1px solid rgba(0, 161, 255, 0.1);
  padding: 5px;
  position: relative;
  overflow: hidden;
}

.log-item:hover {
  opacity: 1;
  transform: translateY(-3px);
  background: rgba(0, 40, 80, 0.2);
  border-color: rgba(0, 161, 255, 0.3);
  box-shadow: 0 5px 15px rgba(0, 161, 255, 0.3),
    0 0 20px rgba(0, 161, 255, 0.15);
}

.log-time {
  font-family: "Courier New", monospace;
  font-size: 0.75rem;
  color: #fff;
  margin-bottom: 8px;
  white-space: nowrap;
  font-weight: bold;
  padding: 3px;
  background: rgba(0, 161, 255, 0.1);
  border-radius: 3px;
  width: 100%;
  text-align: center;
  z-index: 2;
  position: relative;
}
.log-output_class_name {
  margin-top: 5px;
  font-family: "Courier New", monospace;
  font-size: 0.75rem;
  color: #fff;
  font-weight: bold;
}

.face-img-box {
  width: 100%;
  height: 150px; /* 固定图片高度 */
  position: relative;
  /* border: 2px solid rgba(0, 210, 255, 0.4);
  box-shadow: inset 0 0 15px rgba(0, 210, 255, 0.2),
    0 0 10px rgba(0, 210, 255, 0.15); */
  border-radius: 4px;
  overflow: hidden;
  background: #000;
  flex: 1;
}

.face-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.9;
  filter: brightness(1.1) contrast(1.1);
  transition: transform 0.5s ease;
}

.log-item:hover .face-img {
  transform: scale(1.08);
}

/* 滚动控制按钮 */
.scroll-controls {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 5px;
  pointer-events: none; /* 让点击穿透到下方 */
  z-index: 10;
}

.scroll-btn {
  pointer-events: auto; /* 按钮本身可以点击 */
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 50%;
  background: rgba(0, 161, 255, 0.3);
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
  box-shadow: 0 0 10px rgba(0, 161, 255, 0.3);
}

.scroll-btn:hover {
  background: rgba(0, 210, 255, 0.6);
  box-shadow: 0 0 15px rgba(0, 210, 255, 0.5);
  transform: scale(1.1);
}

.scroll-btn:active {
  transform: scale(0.95);
}

/* 占位符样式 */
.log-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 180px;
  color: #667788;
  font-size: 0.9rem;
  font-style: italic;
}

.placeholder-text {
  padding: 15px;
  background: rgba(0, 40, 80, 0.1);
  border-radius: 6px;
  border: 1px dashed rgba(0, 161, 255, 0.3);
}

/* 响应式调整 */
@media screen and (max-height: 700px) {
  .log-item {
    width: 160px;
    min-width: 160px;
    height: 160px;
    padding: 8px;
  }

  .face-img-box {
    height: 110px;
  }

  .log-time {
    font-size: 0.7rem;
    margin-bottom: 6px;
    padding: 2px 8px;
  }
}

/* 当只有少量数据时，不显示滚动条 */
.log-scroll-wrapper:not(.has-content)::-webkit-scrollbar {
  display: none;
}

.log-scroll-wrapper:not(.has-content) {
  scrollbar-width: none;
}

/* === 右侧模块：晨检公示 (fixed height: 32vh) === */
/* .health-fixed-panel {
  flex: 0 0 35%;
  display: flex;
  flex-direction: column;
}

.health-layout {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 5px;
} */

/* 列表头 */
.health-list-header {
  display: flex;
  background: rgba(0, 161, 255, 0.2);
  border-radius: 2px;
  padding: 6px 0;
  margin-bottom: 5px;
  flex-shrink: 0;
}
.health-list-header span {
  text-align: center;
  color: #00d2ff;
  font-size: 0.8rem;
  font-weight: bold;
}

/* 滚动容器 */
.health-scroll-mask {
  flex: 1;
  overflow: hidden;
  position: relative;
  height: 100%;
}
.health-scroll-content {
  width: 100%;
  animation: moveUp 50s linear infinite;
  will-change: transform;
}
.health-scroll-content:hover {
  animation-play-state: paused;
}

.health-list-item {
  display: flex;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  align-items: center;
}
.health-list-item:nth-child(even) {
  background: rgba(255, 255, 255, 0.03);
}
.person-img {
  width: 50px;
  height: 45px;
  cursor: pointer;
  object-fit: cover;
  margin-right: 4px;
  border-radius: 2px;
  border: 1px solid #dcdfe6;
}

.scene-img {
  width: 50px;
  height: 45px;
  cursor: pointer;
  object-fit: cover;
  border-radius: 2px;
  border: 1px solid #dcdfe6;
}

/* 图片 hover 效果 */
.person-img:hover,
.scene-img:hover {
  transform: scale(1.1);
  transition: transform 0.2s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* 错误状态样式 */
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 12px;
  border-radius: 2px;
}

.col-1 {
  width: 15%;
  text-align: center;
  font-size: 0.85rem;
}
.col-2 {
  width: 15%;
  text-align: center;
  color: #00d2ff;
}
.col-3 {
  width: 15%;
  text-align: center;
}
.col-4 {
  width: 15%;
  text-align: center;
}
.col-5 {
  width: 18%;
  text-align: center;
}
.col-6 {
  width: 22%;
  text-align: center;
}
.status-pill {
  font-size: 0.7rem;
  padding: 1px 6px;
  border-radius: 10px;
}
.status-pill.ok {
  border: 1px solid #00ff00;
  color: #00ff00;
  background: rgba(0, 255, 0, 0.1);
}

/* === 右侧其他模块 === */
.health-cert-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.health-cert {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2列 */
  grid-template-rows: repeat(2, 1fr); /* 2行 */
  gap: 8px; /* 格子间距 */
  height: 100%;
  width: 100%;
  grid-auto-flow: row; /* 按行排列 */
}
.cert-card {
  background: #1a2a40;
  border: 1px solid #334466;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}
.cert-card:hover {
  border-color: #00d2ff;
  box-shadow: 0 0 10px rgba(0, 210, 255, 0.3);
  transform: translateY(-2px);
}
.cert-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 8px;
}
.cert-photo {
  width: 100%;
  height: 100%; /* 调整图片区域高度 */
  object-fit: cover; /* 改为cover填充 */
  border: 1px solid #445566;
  border-radius: 2px;
  background: #0a1420;
}
.cert-name {
  margin-top: 8px;
  color: #fff;
  font-size: 0.85rem;
  font-weight: bold;
  text-align: center;
  padding: 2px 5px;
  background: rgba(0, 40, 80, 0.3);
  border-radius: 3px;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

/* Fade 动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media screen and (max-height: 800px) {
  .header {
    height: 10vh;
  }
}
</style>
